module.exports = __webpack_public_path__ + "static/024-0716bf4e3f795aa60146a4e4421278ca.jpg";